// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";

// Store
import { Store } from "#/store";

// Model
import { Userinfo } from "#/common/interfaces/auth/Userinfo";
import { UserinfoError } from "#/common/interfaces/auth/UserinfoError";
import { Api } from ".";

export class IdentityService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new IdentityService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async freigabeBeantragen(
    appId: number,
    freigeberId: number,
    spartenId: number,
    reason: string
  ): Promise<any> {
    let queryUrl =
      Store.instance.ui.identityApiUrl + `/applikation/${appId}/beantragen`;
    const response = await this.http.post<any>(queryUrl, {
      freigeber: freigeberId,
      sparte: spartenId,
      reason: reason,
    });

    return response.body!;
  }

  public async fetchUserCountries(): Promise<any> {
    const userInfo = await Api.authService.getUserinfo("", "");
    let queryUrl =
      Store.instance.ui.identityApiV2Url + `users/${(userInfo as Userinfo).id}`;
    const response = await this.http.get<any>(queryUrl);

    return response.body!;
  }
}
